<div class="p-12">
  <div class="mat-elevation-z8">
    <mat-table [dataSource]="recentActivities">

      <ng-container matColumnDef="case_id">
        <mat-header-cell *matHeaderCellDef> Case </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button mat-button color="accent" (click)="openCase(element)" style="text-transform:uppercase;">
            {{element.case_number || 'Open'}}
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="time">
        <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ cleanDate(element.time) }} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="message">
        <mat-header-cell *matHeaderCellDef> Message </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.message }} </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <mat-paginator #paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/recentActivity/recentActivity.component.html